/**
 * Trigger: tr_currencies_soft_delete
 * Purpose: Cascade soft delete and update positions when a currency is soft deleted
 * Table: currencies
 * Event: UPDATE OF is_deleted
 */
export const TR_CURRENCIES_SOFT_DELETE = `
CREATE TRIGGER tr_currencies_soft_delete
UPDATE OF is_deleted ON currencies
BEGIN
  UPDATE account_daily_balances
  SET is_deleted = new.is_deleted
  WHERE currency_id = old._id;

  UPDATE account_balances
  SET is_deleted = new.is_deleted
  WHERE currency_id = old._id;

  UPDATE planned_expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_expenses),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE planned_incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_incomes),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM expenses),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM incomes),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE account_initial_balances
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM account_initial_balances),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE account_transfers
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM account_transfers),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE creditors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM creditors),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE creditor_payments
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM creditor_payments),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE debtors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtors),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE debtor_payments
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtor_payments),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE exchanges
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM exchanges),
      updated_at = strftime('%s', 'now')
  WHERE (currency_in_id = old._id OR currency_out_id = old._id)
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE exchange_rates
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM exchange_rates),
      updated_at = strftime('%s', 'now')
  WHERE currency_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE currencies
  SET position = position - 1,
      updated_at = strftime('%s', 'now')
  WHERE new.is_deleted <> 0
    AND position > old.position
    AND is_deleted = 0;

  UPDATE currencies
  SET is_default = 1
  WHERE new.is_deleted <> 0
    AND old.is_default = 1
    AND is_deleted = 0
    AND position = (
      SELECT min(position) FROM currencies
      WHERE is_deleted = 0 AND _id <> old._id
    );
END;
`;
